module.exports = __webpack_public_path__ + "static/media/icon_attendance.d5c1d3ea.svg";